var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16646 14.0006C0.935744 14.0005 0.710221 13.932 0.518402 13.8037C0.326584 13.6753 0.177082 13.4929 0.0887972 13.2796C0.000512328 13.0662 -0.0225923 12.8314 0.0224048 12.6049C0.0674019 12.3784 0.178481 12.1703 0.341598 12.0069L12.0087 0.327847C12.2287 0.115102 12.5234 -0.00261684 12.8294 4.41499e-05C13.1353 0.00270514 13.4279 0.125533 13.6442 0.342073C13.8605 0.558613 13.9832 0.851539 13.9859 1.15776C13.9885 1.46398 13.8709 1.759 13.6584 1.97927L1.99132 13.6584C1.88312 13.767 1.75455 13.8531 1.613 13.9118C1.47144 13.9706 1.31969 14.0007 1.16646 14.0006Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8331 14.0006C12.6799 14.0007 12.5282 13.9706 12.3866 13.9118C12.245 13.8531 12.1165 13.767 12.0083 13.6584L0.341181 1.97927C0.128656 1.759 0.0110577 1.46398 0.013716 1.15776C0.0163742 0.851539 0.139076 0.558613 0.355393 0.342073C0.571711 0.125533 0.864336 0.00270514 1.17024 4.41499e-05C1.47615 -0.00261684 1.77086 0.115102 1.99091 0.327847L13.658 12.0069C13.8211 12.1703 13.9322 12.3784 13.9772 12.6049C14.0222 12.8314 13.9991 13.0662 13.9108 13.2796C13.8225 13.4929 13.673 13.6753 13.4812 13.8037C13.2894 13.932 13.0639 14.0005 12.8331 14.0006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.15c1c0d0286155498c50b8bd94255bfa.svg";
export { ForwardRef as ReactComponent };